import { useAuth } from "@/contexts/AuthContext";
import ProfileForm from "@/components/settings/ProfileForm";
import SettingsContentWrapper from "./SettingsContentWrapper";

function ProfileSettingsContent() {
  const { user, organization } = useAuth();

  if (!user || !organization) {
    return (
      <SettingsContentWrapper title="My Profile">
        <div className="flex items-center justify-center h-64">
          <div className="text-center">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-gray-900 mx-auto mb-4"></div>
            <p className="text-muted-foreground">Loading account information...</p>
          </div>
        </div>
      </SettingsContentWrapper>
    );
  }

  return (
    <SettingsContentWrapper 
      title="My Profile" 
      description="Manage your account settings and profile information"
    >
      <div className="space-y-6">
        {/* Profile Section */}
        <ProfileForm />


      </div>
    </SettingsContentWrapper>
  );
}

export default ProfileSettingsContent; 